var $f4095fb5a72adbe6$exports = {};
$f4095fb5a72adbe6$exports = {
    "close": `Cerrar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notificaci\xf3n`,
            other: ()=>`${formatter.number(args.count)} notificaciones`
        })}.`
};


export {$f4095fb5a72adbe6$exports as default};
//# sourceMappingURL=es-ES.module.js.map
